import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import * as S from './DesktopFiltersHeader.styles';
import { useServerDataContext } from '@/contexts';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';
import { QUERY, ROOT_CATEGORY_SLUG } from '@/constants/common';
import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';
import { SearchResultsPageTestIds } from '@/__e2e__/testIds/search-results-page';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

type Props = {
  isLoading?: boolean;
  isResetButtonDisabled: boolean;
};

export const DesktopFiltersHeader = ({
  isLoading,
  isResetButtonDisabled,
}: Props) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { currentCategory: serverCurrentCategory } = useServerDataContext();
  const { currentCategory = serverCurrentCategory } = useCurrentCategory();

  function handleResetFilters() {
    router.replace(
      `/${currentCategory?.path ?? ROOT_CATEGORY_SLUG}?${
        QUERY.keywords_source
      }=${KeywordsSource.Typewritten}`,
      undefined,
      { scroll: false }
    );
  }

  if (isLoading) {
    return (
      <S.Container>
        <SkeletonLoader width={65} height={17} borderRadius={7} />
        <SkeletonLoader width={65} height={17} borderRadius={7} />
      </S.Container>
    );
  }

  return (
    <S.Container data-testid={SearchResultsPageTestIds.desktopFilters.header}>
      <S.Title
        data-testid={SearchResultsPageTestIds.desktopFilters.headerTitle}
      >
        {t('common.filters')}
      </S.Title>
      <S.ResetButton
        data-testid={SearchResultsPageTestIds.desktopFilters.resetButton}
        disabled={isResetButtonDisabled}
        aria-disabled={isResetButtonDisabled}
        onClick={handleResetFilters}
      >
        {t('common.reset')}
      </S.ResetButton>
    </S.Container>
  );
};
